<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">短地址访问结果</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
            <div class="formbody">    
                <ul class="seachform">
                <li><label>任务编号</label><input name="" v-model="smsid" type="text" class="scinput" /></li>
                <li><label>手机号码</label><input name="" v-model="mobile" type="text" class="scinput" style="width:300px;"/></li>
                <li><label>短地址</label><input name="" v-model="shortUrl" type="text" class="scinput" style="width:300px;"/></li>
            </ul>
            <ul class="seachform">
                <li>
                    <label>发送时间</label>
                    <el-date-picker v-model="startTime"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期" />
                    <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期" />
                </li>
                <li>
                    <label>
                        <input type="checkbox" id="checkClick" checked name="checkClick"  value="1"/>已点击号码
                        <input type="checkbox" id="checkClick" name="checkClick"  value="0"/>未点击号码
                        <!-- <el-checkbox-group v-model="checkList">
                            <el-checkbox label="已点击号码"></el-checkbox>
                            <el-checkbox label="未点击号码"></el-checkbox>
                        </el-checkbox-group> -->
                    </label>
                </li>
                <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
                <!-- <li><input class="cancel" type="button" value="导出"></li> -->
            </ul>        
            <table class="tablelist" style="border-collapse:collapse;table-layout:fixed;">
                <thead>
                <tr>
                    <th width="15%">手机号码</th>
                    <th width="25%">短地址</th>
                    <th width="5%">点击数</th>
                    <th width="15%">点击时间</th>
                    <th width="15%">操作系统</th>
                    <th width="6%">浏览器</th>
                    <th width="6%">ip</th>
                    <th width="6%">号码归属地</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in shortSmsVisitList" :class="{odd:index%2!=0}">
                    <td width="15%"><a href="">{{item.mobile}}</a></td> 
                    <td width="25%" >{{item.shortUrl}}</td>
                    <td width="5%">{{item.clickCount}}</td>
                    <td width="15%" >{{item.clickTime}}</td>
                    <td width="15%">{{item.clickIOS}}</td>
                    <td width="6%">{{item.clickBrowser}}</td>
                    <td width="6%">{{item.clickIp}}</td>
                    <td width="6%">{{item.mobileArea}}</td>
                </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="jian">&nbsp;</div>        
            </div> 

            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            shortSmsVisitList:[],
            loadingShow: true,
            smsid:this.$route.query.smsid == undefined ? "" : this.$route.query.smsid,
            mobile:'',
            shortUrl:'',
            startTime:'',
            endTime:'',      
            // checkList: ['已点击号码']   
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val){
            this.pageChange(val);
        },
        handleCurrentChange(val){
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            var checkers = document.getElementsByName('checkClick');
            var checkClick = "";
            for ( var i = 0; i < checkers.length; i++)
            {
                if(checkers[i].checked == true){
                    if( checkClick == "" )
                    {
                        checkClick = checkers[i].value;
                    }
                    else
                    {
                        checkClick = checkClick + "," + checkers[i].value;
                    }
                }
                
            }
            let data = {'pageSize':50,pageIndex:pageIndex,'smsid':this.smsid,'mobile':this.mobile,'shortUrl':this.shortUrl,'startTime':this.startTime,'endTime':this.endTime,'checkClick':checkClick};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getpagesmsshortvisit.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.shortSmsVisitList = res.data.shortSmsVisitList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsshortvisit.vue